export default class PictureTextGridTile {
    readonly position: number;
    readonly subline: string;

    constructor(tileDom: Element, position: number) {
        this.subline = tileDom.getAttribute("footer-headline") || "";
        this.position = position;
        tileDom.setAttribute("data-tile-position", position.toString())
    }
}